module.exports = {
	"articleTitle1": "Ahmo's to join Union food court",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Ahmo's Gyros & Deli",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/new-fast-salad-restaurant-brings-fresh-taste-table",
	"articleSnippet1": "Apr 21, 2013 ... Ahmo's Gyros and Deli will join current vendors Wendy's, Subway and Panda \nExpress in MUG in August, while Pizza Hut, Mrs. Fields, Freshens ...",
	"articleSnippet2": "",
	"foodRecommendations": [],
	"articleTitle2": "",
	"address": "341 E Huron St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.281643,
		"lng": -83.744217
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ahmos.json
// module id = 803
// module chunks = 0